import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";

export const MermaidContainer = styled(Box)(({ theme }) => ({
  display: "block",
  width: "100%",
  maxWidth: "100%",
  margin: "8px 0",
  padding: "12px",
  borderRadius: "8px",
  backgroundColor: theme.palette.background.default,
  border: `1px solid ${theme.palette.divider}`,
  overflowX: "auto",
  "& svg": {
    display: "block",
    maxWidth: "100%",
    height: "auto",
  },
}));

export const MermaidPre = styled("pre")(({ theme }) => ({
  margin: 0,
  fontFamily:
    'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
  fontSize: "12px",
  lineHeight: 1.5,
  color: theme.palette.text.primary,
  whiteSpace: "pre-wrap",
  wordBreak: "break-word",
}));

export const MermaidError = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.main,
  fontSize: "12px",
  fontWeight: 600,
  marginBottom: "6px",
}));
